import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useMediaQuery, useTheme } from '@mui/material';

import { EMPTY_OBJECT } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

interface Props {
  readonly id: Id;
}

export const LoadingSection = ({ id }: Readonly<Props>) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Accordion
      disableGutters
      elevation={0}
      expanded
      slotProps={{ transition: { unmountOnExit: true, timeout: 0 } }} // performance
      sx={{
        width: '100%',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        aria-controls={`accordion-${id}-content`}
        aria-label="Déplier"
        expandIcon={<ExpandMoreIcon />}
        id={`accordion-${id}-header`}
        sx={{
          backgroundColor: (theme) => theme.palette.grey[200],
          color: (theme) =>
            theme.palette.getContrastText(theme.palette.grey[200]),
          ...(!matches
            ? {
                pl: '4px',
                pr: '8px',

                '& :first-of-type': {
                  minWidth: 0,
                },
              }
            : EMPTY_OBJECT),
        }}
      >
        <Stack direction="row" spacing={2} sx={{ flexGrow: 1 }}>
          <Skeleton height={20} variant="circular" width={20}>
            <Avatar />
          </Skeleton>
          <Box sx={{ flexGrow: 1 }}>
            <Skeleton width="40%" />
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
          background: (theme) => theme.palette.grey[200],
        }}
      >
        <Box
          sx={{
            margin: 0,
            padding: 2,
            border: (theme) => `${theme.palette.grey[200]} 5px solid`,
            borderRadius: '8px',
            backgroundColor: (_theme) => 'white',
          }}
        >
          <Skeleton width="50%" />
          <Skeleton width="80%" />
          <Skeleton width="70%" />
          <Skeleton width="60%" />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
